import { CloseCircleFilled } from '@ant-design/icons';
import React, { useMemo, useState } from 'react';
import { filterCapabilities, KEY_SPLIT, vesselOpType } from "../";
import { VESSEL_TYPE } from '../../../../util/varibles/constants';
import { firstLetter } from '../../../../util/varibles/global';
import { IVessel } from '../../../../util/varibles/interface';
import styles from './style.module.scss';

interface IProps {
    vessels?: IVessel[]

    onChange(value: string[]): void
}

const Capabilities: React.FC<IProps> = ({ vessels = [], onChange }) => {
    const [value, setValue] = useState(new Set<string>([]));
    const [open, setOpen] = useState(false);
    const root: any = React.useRef(null);

    const handleClick = () => {
        if (!open && root.current)
            root.current.focus();

        setOpen(!open);
    }

    const handleSelect = (checked: boolean, id: string) => {
        const selected = new Set(value);
        if (checked)
            selected.add(id);
        else
            selected.delete(id);
        setValue(selected);
        onChange(Array.from(selected))
    }

    const handleClear = () => {
        setValue(new Set<string>([]));
        onChange([]);
    }

    const list = Array.from(value);

    const equipment = useMemo(() => {
        const result: { [id: string]: { name: string } } = {};
        vessels.forEach(item => {
            const { capabilities = [], type } = item;
            if (type === VESSEL_TYPE.SERVICE)
                capabilities.forEach(sub => {
                    result[[VESSEL_TYPE.SERVICE, sub.type].join(KEY_SPLIT)] = { name: firstLetter(sub.type) }
                })
        })
        return result
    }, [vessels])

    const result = list.map((key: any) => {
        const { name = null } = vesselOpType[key] || equipment[key] || {};
        return name
    }).join(', ');

    return <div className={styles.wrapper} ref={root} tabIndex={0} onBlur={() => setOpen(false)}>
        <div className={styles.view} onClick={handleClick}>
            {list.length === 0 ?
                <div className={styles.placeholder}>Filter by capabilities</div>
                : <>
                    <div className={styles.selected} title={result}>{result}</div>
                    <CloseCircleFilled className={styles.close} onClick={handleClear} />
                </>
            }
        </div>
        <div className={styles.dropdown}>
            <div className={styles.options}>
                {filterCapabilities.map((item: any, index: number) => <div className={styles.section} key={index}>
                    {item.map(({ id, name }: any) => {
                        const checked = value.has(id);
                        return <div
                            key={id}
                            className={styles.option}
                            data-selected={checked}
                            onClick={() => handleSelect(!checked, id)}
                        >
                            {name}
                        </div>
                    })}
                </div>)}
                {Object.keys(equipment).length > 0 && <div className={styles.section} key='equipment'>
                    {Object.keys(equipment).map((id) => {
                        const checked = value.has(id);
                        return <div
                            key={id}
                            className={styles.option}
                            data-selected={checked}
                            onClick={() => handleSelect(!checked, id)}
                        >
                            {equipment[id].name}
                        </div>
                    })}
                </div>}
            </div>
        </div>
    </div>;
};

export default Capabilities;
